import classNames from "classnames";
import { CheckoutAlignment } from "../../types/builder";

const align = {
  [CheckoutAlignment.LEFT]: "items-start",
  [CheckoutAlignment.CENTER]: "items-center",
  [CheckoutAlignment.RIGHT]: "items-end",
};

type DivProps = JSX.IntrinsicElements["div"];

type CheckoutComponentAlignmentContainerProps = DivProps & {
  alignment: CheckoutAlignment;
  className?: string;
};

const CheckoutComponentAlignmentContainer: React.FC<
  CheckoutComponentAlignmentContainerProps
> = ({ alignment, className, children, ...props }) => {
  return (
    <div
      {...props}
      className={
        classNames(className, "flex flex-col w-full", align?.[alignment]) || ""
      }
    >
      {children}
    </div>
  );
};

export default CheckoutComponentAlignmentContainer;
